<template>
  <div class="category-page">
    <div class="category-header">
      <div class="header-action" @click="$router.go(-1)">&#xe64f;</div>
      <h1>Categories</h1>
      <div class="header-spacer"></div>
    </div>
    <goodsclass-body></goodsclass-body>
  </div>
</template>

<script>
import GoodsclassBody from './GoodsclassBody'
export default {
  name: 'HomeGoodsclass',
  components: {
    GoodsclassBody
  },
  computed: {
    // isShowTabbar() {
    //   let isFromHome = this.$route.params.isFromHome;
    //   if (isFromHome) {
    //     return false;
    //   }
    //   return true;
    // }
  }
}
</script>

<style scoped lang='scss'>
.category-page {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 2.5rem;
  left: 0;
  height: auto;
  background: #fff;
  color: #202124;
}

.category-header {
  height: 2.8rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 .75rem;
  box-sizing: border-box;
  background: #fff;
  border-bottom: 1px solid #ededed;
  position: relative;
  z-index: 2;
}

.category-header h1 {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-size: 1.08rem;
  font-weight: 700;
  letter-spacing: -.02em;
}

.header-action {
  width: 1.35rem;
  height: 1.6rem;
  line-height: 1.55rem;
  color: #17191c;
  font-size: 1.35rem;
  font-family: iconfont;
  cursor: pointer;
}

.header-spacer {
  width: 1.05rem;
}

</style>
